// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Entry imports
const actions = require('./actions')
const LightweightEngagementTutorialModal = require('./modal-dumb')
const selectors = require('./selectors')

function mapStateToProps(state) {
  return {
    isVisible: selectors.isVisible(state),
    slides: selectors.slides(state),
    slideCount: selectors.slideCount(state)
  }
}

const mapDispatchToProps = {
  onComplete: actions.dismiss
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    LightweightEngagementTutorialModal
  )
)
